export const baseUrl = import.meta.env.VITE_API_BASE_URL
// ****************** Search *********************** //
export const searchEndpointV1 = '/v1/toolkit-search'

// ****************** Toolkits *********************** //
export const toolkitsV1 = 'v1/toolkits'
export const toolkitCategoriesV1 = 'v1/toolkit-categories'
export const toolkitV1 = 'v1/toolkit'

export const toolkitTaxonomyV1 = 'v1/toolkit-taxonomy'

export const toolkitSearchV1 = 'v1/toolkit-search'

export const draftToolkitsV1 = 'v1/draft-toolkit-categories'
export const draftToolkitV1 = 'v1/draft-toolkit'

// ****************** Login *********************** //
export const requestAuthCodeEndpoint = 'v1/authentication-code'
export const csrfEndpoint = 'v1/get-csrf-token'
